import commonReducers from './commonReducers'

const defaultReducers = {
  cacheClear: commonReducers.cacheClear,
  cacheSet: commonReducers.cacheSet,
}

export default defaultReducers
